export default class DynamicEntity extends RpcClass{
    /** @returns {ExtendedPromise<String>} */
    getInstanceLabel() {
        return this.__supplement__?.label;
    }
}
